<template>
  <div ref="scroll_wrap" class="service-wrap">
    <div class="service-header">
      <p>{{$t('upgrade_page_views_dashboard_income_index_1492')}}</p>
    </div>
    <div class="account-content">
      <div class="can-withdraw">
        <div class="tip">
          <span>{{$t('upgrade_page_views_dashboard_income_index_1493')}}</span>
          <el-popover
            trigger="hover"
            class="tips-popover"
            placement="right-start"
            popper-class="settlement-tips-popover"
          >
            <div>
              <div>
                <p
                  v-for="(t, i) in deductList"
                  :key="'deduct-' + i"
                  :class="i === 0 && 'strong'"
                >
                  {{ t }}
                </p>
              </div>
            </div>
            <fps-icon
              slot="reference"
              class="explanation-icon"
              type="question"
            />
          </el-popover>
        </div>
        <div class="value">${{ accountInfo.reward }}</div>
      </div>
      <div class="line" />
      <div class="not-withdraw">
        <div class="tip">
          <span>{{$t('upgrade_page_views_dashboard_income_index_1494')}}</span>
          <el-popover
            trigger="hover"
            class="tips-popover"
            placement="right-start"
            popper-class="settlement-tips-popover"
          >
            <div>
              <div>
                <p>{{$t('upgrade_page_views_dashboard_income_index_1495')}}</p>
                <p>{{$t('upgrade_page_views_dashboard_income_index_1496')}}</p>
                <p>{{$t('upgrade_page_views_dashboard_income_index_1497')}}</p>
                <p>{{$t('upgrade_page_views_dashboard_income_index_1498')}}</p>
                <p>{{$t('upgrade_page_views_dashboard_income_index_1499')}}</p>
                <p>{{$t('upgrade_page_views_dashboard_income_index_1500')}}</p>
                <p>{{$t('upgrade_page_views_dashboard_income_index_1501')}}</p>
              </div>
            </div>
            <fps-icon
              slot="reference"
              class="explanation-icon"
              type="question"
            />
          </el-popover>
        </div>
        <div class="value">${{ accountInfo.pendingClearance }}</div>
      </div>
      <div class="not-withdraw">
        <div class="tip">{{$t('upgrade_page_views_dashboard_income_index_1502')}}</div>
        <div class="value">${{ accountInfo.totalIncome }}</div>
      </div>
      <div class="empty" />
      <button class="service-btn" @click="transBalance">{{$t('upgrade_page_views_dashboard_income_index_1503')}}</button>
      <button class="service-btn withdrawal-btn" @click="withdrawal">{{$t('upgrade_page_views_dashboard_income_index_1504')}}</button>
    </div>
    <div class="following-water">
      <div class="select-balance-type">
        <div class="type-title">{{$t('upgrade_page_views_wallet_index_687')}}</div>
        <div class="buttons">
          <div
            :class="['pointer', !showSettlement && 'active']"
            @click="showSettlement = false"
          >{{$t('upgrade_page_views_wallet_index_688')}}</div>
          <div
            :class="['pointer', showSettlement && 'active']"
            @click="showSettlement = true"
          >{{$t('upgrade_page_views_wallet_index_689')}}</div>
        </div>
      </div>
      <div class="service-msg">
        <p class="service-msg-1">{{$t('upgrade_page_views_wallet_index_690')}}</p>
        <p class="service-msg-2">{{$t('upgrade_page_views_wallet_index_691')}}</p>
        <p class="service-msg-3">{{$t('upgrade_page_views_wallet_index_692')}}</p>
        <p class="service-msg-4">{{$t('upgrade_page_views_wallet_index_693')}}</p>
        <p class="service-msg-5">{{$t('upgrade_page_views_wallet_index_694')}}</p>
      </div>
      <div class="service-list" v-loadMore="getMoreMasterList">
        <accountCard
          v-for="(item, index) in serveList"
          :key="index"
          :serveObj="item"
          :is-settlement="showSettlement"
        />
        <div
          v-if="showSettlement ? isSettlementLoading : isLoading"
          class="loading-line"
        >
          <i class="el-icon-loading" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import accountCard from '@/components/AccountCard/index';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      serveList: [],
      lastUid: '',
      requestQuery: {
        lastItemUuid: null,
        offset: 10
      },
      deductList: [],
      isLoading: false,
      isFinish: false,
      showSettlement: false,
      isSettlementLoading: false,
      couponsList: [] //
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'accountInfo'])
  },
  watch: {
    showSettlement(value) {
      this.serveList = [];
      if (!value) {
        this.isFinish = false;
        this.requestQuery = {
          lastItemUuid: null,
          offset: 10
        };
      }
      this.toGetList();
    }
  },
  components: {
    accountCard
  },
  created() {
    this.$store.dispatch('app/getUserAccount');
    this.toGetList();
    this.getCouponsList();
    this.getDeduct();
  },
  methods: {
    getDeduct() {
      // 登录情况下获取抽成信息
      this.$http.get('/account/stolen/content').then(({ data }) => {
        this.deductList = data.split(/\n/).filter(item => item.trim() !== '');
      });
    },
    recharge() {
      if (this.userInfo) {
        this.$router.push({
          name: 'Saving'
        });
      } else {
        this.$util.Login().then(() => {
          this.$router.push({
            name: 'Saving'
          });
        });
      }
    },
    getSettlementingList() {
      if (this.isSettlementLoading) return;
      this.isSettlementLoading = true;
      // 帳户结算中列表
      this.$http
        .get('/settlement/list')
        .then(({ data }) => {
          this.isSettlementLoading = false;
          if (this.showSettlement) {
            this.serveList = data;
          }
        })
        .catch(() => {
          this.isSettlementLoading = false;
        });
    },
    toGetList() {
      if (this.showSettlement) {
        this.getSettlementingList();
      } else {
        this.getList();
      }
    },
    listenWindowScroll() {
      const pageContentHeight = document.body.scrollHeight;
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = document.documentElement.clientHeight;
      if (
        pageContentHeight - windowHeight - scrollTop < 100 &&
        !this.isLoading &&
        !this.isFinish
      ) {
        this.getMoreMasterList();
      }
    },
    getMoreMasterList() {
      if (!this.isLoading && !this.isFinish) {
        this.requestQuery.lastItemUuid = this.serveList.length
          ? this.serveList[this.serveList.length - 1].statementNo
          : null;
        this.getList();
      }
    },
    getList() {
      var params = Object.assign({}, this.requestQuery);
      this.isLoading = true;
      params.statementReceiptKind = 'RevenueDetail';
      // 帳戶管理列表
      this.$http
        .get('/account/statement/list', params)
        .then(({ data }) => {
          if (!this.showSettlement) {
            if (data && Array.isArray(data.pageContent)) {
              const Arr = data.pageContent.map(item => {
                if (item.receiptKind.indexOf('Out') > -1) {
                  item.receiptKind = i18n.t('upgrade_page_views_wallet_index_696');
                  item.amount = '-' + item.amount;
                } else if (item.receiptKind.indexOf('In') > -1) {
                  item.receiptKind = i18n.t('upgrade_page_views_wallet_index_697');
                  item.amount = '+' + item.amount;
                }

                return item;
              });

              this.serveList = params.lastItemUuid
                ? this.serveList.concat(Arr)
                : Arr;
              this.isFinish =
                data.pageContent.length < this.requestQuery.offset;
            }
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.isFinish = true;
        });
    },
    withdrawal() {
      this.$router.push({
        path: '/withdraw'
      });
    },
    transBalance() {
      this.$router.push({
        name: 'transferBalance'
      });
    },
    /**
     * @description: 获取用户優惠券
     */
    getCouponsList() {
      this.$http
        .post('coupon/getUserCouponInfo', {
          couponStatusList: ['EFFECT'],
          userUuid: this.userInfo.uuid
        })
        .then(data => {
          if (data && data.data && data.msg === 'success') {
            this.couponsList = data.data;
          }
        });
    },
    gotoCoupons() {
      this.$router.push('/coupons');
    }
  }
};
</script>

<style lang="scss" scoped>
.settlement-tips-popover {
  font-size: 14px;
  color: #333;
  line-height: 20px;
  .strong {
    font-weight: 600;
    color: #333;
  }

  p {
    color: #333;
  }
}

.account-btn {
  border-radius: 5px;
  margin-right: 28px;
  margin: 20 10 24 0;
  background: none;
  font-weight: 500;
  font-size: 22px;
  line-height: 31px;
  color: #333333;
  // cursor: pointer;
  // &:hover {
  //   color: #ff891e;
  // }
}
// .select-screen {
//   color: #ff891e;
// }
.add-account {
  width: 100%;
  padding: 20px 30px;
  // border-top: 2px solid #f4f4f4;
  box-sizing: border-box;
}
.service-wrap {
  font-style: normal;
  width: 100%;
  height: 100%;
  padding-top: 24px;
  .account-content {
    display: flex;
    align-items: center;
    padding: 0 28px 0 30px;
    box-sizing: border-box;
    margin-bottom: 12px;
    height: 110px;
    @include whiteBox;
    .can-withdraw {
      margin-right: 62px;
      @include flex(center, flex-start, column);
      .tip {
        @include flex;
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-1;
        .tips-popover {
          margin-left: 2px;
          @include flex;
        }
        .explanation-icon {
          font-size: 18px;
          color: $color-gray-3;
        }
      }
      .value {
        margin-top: 8px;
        font-weight: bold;
        color: $color-gray-1;
        font-size: 24px;
        line-height: 34px;
      }
    }
    .line {
      width: 1px;
      height: 54px;
      background: $color-split;
    }
    .empty {
      flex: 1;
    }
    .not-withdraw {
      margin: 0 68px 0 28px;
      @include flex(center, flex-start, column);
      .tip {
        @include flex;
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-3;
        .tips-popover {
          margin-left: 2px;
          @include flex;
        }
        .explanation-icon {
          font-size: 18px;
          color: $color-gray-3;
        }
      }
      .value {
        margin-top: 12px;
        color: $color-gray-1;
        font-size: 16px;
        line-height: 22px;
      }
    }
    .service-btn {
      width: 100px;
      height: 32px;
      @include flex;
      border-radius: 50px;
      background: $color-button;
      font-size: 13px;
      line-height: 18px;
      color: $color-gray-2;
      &.withdrawal-btn {
        background: $color-yellow;
        color: $color-gray-1;
        margin-left: 12px;
      }
    }
  }
  .service-header {
    width: 100%;
    text-align: left;
    display: flex;
    margin-bottom: 36px;
    p {
      cursor: pointer;
      margin: 0 20px 0 0;
      font-weight: 500;
      font-size: 22px;
    }
    .selectTab {
      color: #ffa040;
    }
  }
  .explanation-area {
    span {
      @include flex();
      font-size: 0;
      cursor: pointer;
    }
  }
  .following-water {
    @include whiteBox;
    padding-bottom: 18px;
    margin-bottom: 50px;
    .select-balance-type {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 71px;
      border-bottom: 1px solid $color-split;
      padding: 0 28px;
      .buttons {
        @include flex;
        > div {
          padding: 0 16px;
          height: 32px;
          line-height: 32px;
          font-size: 13px;
          color: $color-gray-2;
          border: 1px solid $color-split;
          &:first-child {
            border-radius: 6px 0 0 6px;
            border-right: none;
          }
          &:last-child {
            border-radius: 0 6px 6px 0;
            border-left: none;
          }
          &.active {
            color: #fff;
            font-weight: 500;
            background: $color-gray-2;
            border: none;
          }
        }
      }
    }
  }
  .hide-btn {
    border: none;
    cursor: unset;
  }
  .service-list {
    min-height: 300px;
    height: 400px;
    overflow: auto;
    margin: 0 28px;
    .loading-line {
      text-align: center;
      padding-top: 20px;
      font-size: 25px;
    }
  }
  .service-msg {
    height: 61px;
    border-bottom: 1px solid $color-split;
    margin: 0 28px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: $color-gray-3;
    .service-msg-1 {
      width: 358px;
    }
    .service-msg-2 {
      width: 134px;
    }
    .service-msg-3 {
      width: 134px;
    }
    .service-msg-4 {
      width: 158px;
    }
    .service-msg-5 {
      width: 140px;
    }
  }
}

.balance-statement {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: #999999;

  & > div {
    flex: 1;
  }
  .clearing {
    display: flex;
    justify-content: center;
    padding-left: 20px;
    img {
      position: relative;
      top: 1px;
    }
  }
  .price-count {
    margin-top: 1px;
    line-height: 22px;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    display: flex;
    justify-content: center;
  }
}
.realizetion {
  font-size: 28px !important;
  line-height: 39px;
  font-weight: normal !important;
}
</style>
